/*
  Grifos · ficha de producto. Al elegir otro acabado, Horizon pide el HTML de la ficha con la variante nueva
  y lanza "shopify:product:select" (assets/variant-picker.js). Con ese HTML:
  - se copian los trozos marcados con data-grifos-actualizar (la cabecera: descuento y acabado del título,
    blocks/grifos-ficha-titulo.liquid), así el texto sale siempre del servidor;
  - se vuelven a pedir las secciones que dependen del acabado ("Completa tu instalación" y "Productos
    similares", marcadas con data-grifos-por-acabado).
  La galería ya la cambia Horizon (assets/media-gallery.js) con las fotos del acabado nuevo.
*/
(function () {
  if (window.grifosFicha) return;
  window.grifosFicha = true;

  document.addEventListener('shopify:product:select', function (evento) {
    var origen = evento.target;
    if (!(origen instanceof Element) || origen.closest('product-card, dialog')) return;
    if (!evento.promise) return;

    evento.promise
      .then(function (resultado) {
        var detalle = resultado && resultado.detail;
        if (!detalle || !detalle.html) return;

        document.querySelectorAll('[data-grifos-actualizar]').forEach(function (actual) {
          var clave = actual.getAttribute('data-grifos-actualizar');
          var nuevo = detalle.html.querySelector('[data-grifos-actualizar="' + clave + '"]');
          if (nuevo && nuevo.innerHTML !== actual.innerHTML) actual.innerHTML = nuevo.innerHTML;
        });

        var variante = detalle.resource && detalle.resource.id;
        if (variante) renovarPorAcabado(variante);
      })
      .catch(function () {});
  });

  function renovarPorAcabado(variante) {
    document.querySelectorAll('[data-grifos-por-acabado]').forEach(function (caja) {
      var url = location.pathname + '?variant=' + variante + '&section_id=' + caja.dataset.grifosPorAcabado;
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var nueva = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-grifos-por-acabado]');
          if (nueva) caja.innerHTML = nueva.innerHTML;
        })
        .catch(function () {});
    });
  }
})();
